module.exports = __webpack_public_path__ + "img/IMG_0470.feea348f.jpg";